module.exports = __webpack_public_path__ + "img/logo-bambinos.4b8e0893.svg";